export default function SVGGradients() {
  return (
    <defs>
      <linearGradient
        id="linear-gradient"
        x1="1200.63"
        y1="3612.61"
        x2="1167.7"
        y2="3618.04"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="0" stopColor="#fff" />
        <stop offset="0.09" stopColor="#fff" stopOpacity="0.97" />
        <stop offset="0.22" stopColor="#fff" stopOpacity="0.9" />
        <stop offset="0.36" stopColor="#fff" stopOpacity="0.79" />
        <stop offset="0.53" stopColor="#fff" stopOpacity="0.62" />
        <stop offset="0.7" stopColor="#fff" stopOpacity="0.42" />
        <stop offset="0.89" stopColor="#fff" stopOpacity="0.16" />
        <stop offset="1" stopColor="#fff" stopOpacity="0" />
      </linearGradient>
      <linearGradient
        id="linear-gradient-2"
        x1="971.08"
        y1="6377.46"
        x2="991.7"
        y2="6464.58"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="0" stopColor="#fff" />
        <stop offset="0.09" stopColor="#fff" stopOpacity="0.97" />
        <stop offset="0.22" stopColor="#fff" stopOpacity="0.9" />
        <stop offset="0.36" stopColor="#fff" stopOpacity="0.79" />
        <stop offset="0.53" stopColor="#fff" stopOpacity="0.62" />
        <stop offset="0.7" stopColor="#fff" stopOpacity="0.42" />
        <stop offset="0.89" stopColor="#fff" stopOpacity="0.16" />
      </linearGradient>
    </defs>
  );
}

export function MobileSVGGradients() {
  return (
    <defs>
      <linearGradient
        id="linear-gradient"
        x1="319.88"
        y1="4409.97"
        x2="373.09"
        y2="4362.53"
        gradientTransform="matrix(1, 0, 0, -1, 0, 8192)"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="0" stopColor="#fff" />
        <stop offset="0.09" stopColor="#fff" stopOpacity="0.97" />
        <stop offset="0.22" stopColor="#fff" stopOpacity="0.9" />
        <stop offset="0.36" stopColor="#fff" stopOpacity="0.79" />
        <stop offset="0.53" stopColor="#fff" stopOpacity="0.62" />
        <stop offset="0.7" stopColor="#fff" stopOpacity="0.42" />
        <stop offset="0.89" stopColor="#fff" stopOpacity="0.16" />
      </linearGradient>
      <linearGradient
        id="linear-gradient-2"
        x1="-2015.6"
        y1="30646.72"
        x2="-1988.04"
        y2="30646.72"
        gradientTransform="translate(-1280.36 28624.78) rotate(180) scale(0.86)"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="0" stopColor="#fff" />
        <stop offset="0.09" stopColor="#fff" stopOpacity="0.97" />
        <stop offset="0.22" stopColor="#fff" stopOpacity="0.9" />
        <stop offset="0.36" stopColor="#fff" stopOpacity="0.79" />
        <stop offset="0.53" stopColor="#fff" stopOpacity="0.62" />
        <stop offset="0.7" stopColor="#fff" stopOpacity="0.42" />
        <stop offset="0.89" stopColor="#fff" stopOpacity="0.16" />
        <stop offset="1" stopColor="#fff" stopOpacity="0" />
      </linearGradient>
      <linearGradient
        id="linear-gradient-3"
        x1="503.73"
        y1="23905.69"
        x2="552.85"
        y2="23905.71"
        gradientTransform="translate(845.26 20435.81) rotate(180) scale(0.76)"
        xlinkHref="#linear-gradient-2"
      />
    </defs>
  );
}
